<div class="card boxshadow">
    <div class="card-body">
        <div class="text-center">
            <div class="m-r-0 align-self-center"><span class="lstick"></span></div>
            <div class="align-self-center max-width">
                <div class="heading">
                    <h6 class="text-muted m-t-10 m-b-0 m-h-2">{{heading}}</h6>
                    <img 
                        src="{{ getIconPath(icon) }}" 
                        [ngClass]="{'red' : icon === 'up', 'green': icon === 'down' }" />
                </div>
                <div [class]="className">
                    <h3 class="h3">{{count}}</h3>
                </div>
                <!-- <h3 class="m-t-0" *ngIf="sev3TotalFirstResponse == 0">NO<br/>CASES</h3>
                <i class="fa fa-spinner fa-spin fa-2x p-2" *ngIf="!cases"></i> -->
            </div>
        </div>
    </div>
</div>

<div class="card boxshadow footer" *ngIf="footerMonth">
    <div class="card-body">
        {{footerMonth}}
    </div>
</div>